export const header = {
  headerTitle: 'Organization Profile',
  headerDescription: '',
  headerAction1: {
    id: 'createProfile',
    label: 'Create Profile',
    icon: 'PlusIcon',
  },
};
